import { render } from "./OutlinedIconTextButton.vue?vue&type=template&id=6287c594&ts=true"
import script from "./OutlinedIconTextButton.vue?vue&type=script&lang=ts"
export * from "./OutlinedIconTextButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__